<template>
  <div class="smart">
    <div class="container">
      <div class="row align-items-top">
        <div class="col-lg-7 col-md-7 text-smart">
          <div class="claim">
            Elevate Care, One Insight at a Time
          </div>
          <p>
            Monitor and measure progress with ease. HeartBeatFam simplifies
            cognition tracking, providing clear benchmarks and milestones to
            celebrate along the way.
          </p>
          <div class="spacer"></div>
        </div>
        <div class="col-lg-5 col-md-5 img-smart">
          <img
            src="../../assets/img/home/grandparent-love-handsign.png"
            alt="Kissing Grandma"
            class="main-img"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GainInsight",
  data() {
    return {
      email: "",
      error: ""
    };
  },
  methods: {
    handleEarlyAccessButtonClick() {
      this.error = "";
      if (!this.validateEmail(this.email)) {
        this.error = "Please Enter a valid email!";
        return;
      }
      this.$emit("applied", this.email);
      this.email = "";
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
};
</script>

<style lang="scss" scoped>
.smart {
  background: url("../../assets/img/home/elevate-care-bg.png") no-repeat center
    center;
  background-size: cover;
  position: relative;
  width: 100vw;
  min-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 50px 0;
  padding-bottom: 0;
}

.img-smart {
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-img {
  width: auto;
  max-width: 900px;
  height: auto;
  object-fit: contain;
  margin-bottom: -10px;
}

.text-smart {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Moves text higher */
  align-items: flex-start;
  font-family: "Lato";
  // margin-top: -30px; /* Adjust this to control how high the text goes */
  p {
    font-size: 22px;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
}

.claim {
  font-family: "Lato";
  font-style: normal;
  font-weight: 900;
  font-size: 64px;
  line-height: 65px;
  color: #ffffff;
  margin-bottom: 30px;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.spacer {
  height: 20vh; // This creates a space between the heading and description
}

@media (max-width: 768px) {
  .smart {
    padding-left: 0;
    padding-right: 0;
    background-size: contain;
    min-height: -webkit-fill-available;
    background-color: #6699ff;
    display: flex;
    bottom: 0;
  }

  .main-img {
    max-width: 100%;
    height: auto;
  }

  .claim {
    font-size: 36px;
    line-height: 1.2;
    margin-bottom: 20px;
  }

  .input-email {
    flex-direction: column; /* Stack input and button on mobile */
    align-items: flex-end; /* Align input and button to the right on mobile */
    gap: 10px;
  }

  .btn-success {
    width: 100%; /* Full width button on mobile */
  }

  .spacer {
    display: none; // Hides the spacer on mobile view to reduce unnecessary space
  }
}
</style>
